import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, Teleport as _Teleport, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "home-shell" }
const _hoisted_2 = {
  key: 0,
  class: "app-loading-overlay"
}
const _hoisted_3 = {
  key: 0,
  class: "suspension-overlay"
}
const _hoisted_4 = { class: "suspension-panel" }
const _hoisted_5 = { class: "suspension-stats" }
const _hoisted_6 = { class: "susp-stat" }
const _hoisted_7 = { class: "susp-stat-value" }
const _hoisted_8 = { class: "susp-stat" }
const _hoisted_9 = { class: "susp-stat-value" }
const _hoisted_10 = {
  key: 0,
  class: "suspension-form"
}
const _hoisted_11 = {
  key: 0,
  class: "susp-error"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 1,
  class: "susp-success"
}
const _hoisted_14 = {
  key: 1,
  class: "saving-overlay"
}
const _hoisted_15 = { class: "home-body" }
const _hoisted_16 = {
  key: 9,
  class: "panel"
}
const _hoisted_17 = {
  key: 0,
  class: "content-header"
}
const _hoisted_18 = {
  key: 22,
  class: "item-card"
}
const _hoisted_19 = {
  key: 5,
  class: "dds-overlay"
}
const _hoisted_20 = { class: "dds-modal" }
const _hoisted_21 = { class: "subtitle" }
const _hoisted_22 = {
  ref: "ddsVideoRef",
  class: "dds-video",
  autoplay: "",
  playsinline: "",
  muted: ""
}
const _hoisted_23 = { class: "actions" }
const _hoisted_24 = ["src"]
const _hoisted_25 = {
  key: 1,
  class: "subtitle",
  style: {"color":"#a54b2a"}
}
const _hoisted_26 = { class: "quick-modal" }
const _hoisted_27 = { class: "quick-modal-header" }
const _hoisted_28 = { class: "quick-modal-body" }
const _hoisted_29 = { class: "quick-project-list" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "quick-modal-footer" }
const _hoisted_32 = { class: "quick-modal quick-modal--form" }
const _hoisted_33 = { class: "quick-modal-header" }
const _hoisted_34 = { class: "quick-modal-body" }
const _hoisted_35 = { class: "quick-form-field" }
const _hoisted_36 = ["value"]
const _hoisted_37 = { class: "quick-form-field" }
const _hoisted_38 = ["value"]
const _hoisted_39 = { class: "quick-form-field" }
const _hoisted_40 = { class: "quick-form-field" }
const _hoisted_41 = { class: "quick-form-field" }
const _hoisted_42 = {
  key: 0,
  class: "quick-image-preview"
}
const _hoisted_43 = ["src"]
const _hoisted_44 = {
  key: 0,
  class: "quick-form-error"
}
const _hoisted_45 = { class: "quick-modal-footer" }
const _hoisted_46 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardNavbar = _resolveComponent("DashboardNavbar")!
  const _component_DashboardSidebar = _resolveComponent("DashboardSidebar")!
  const _component_OverviewPanel = _resolveComponent("OverviewPanel")!
  const _component_ReportsPanel = _resolveComponent("ReportsPanel")!
  const _component_MaintenanceOverviewPanel = _resolveComponent("MaintenanceOverviewPanel")!
  const _component_MaintenanceProjectPanel = _resolveComponent("MaintenanceProjectPanel")!
  const _component_MaintenanceManualsPanel = _resolveComponent("MaintenanceManualsPanel")!
  const _component_MaintenanceServiceOrdersPanel = _resolveComponent("MaintenanceServiceOrdersPanel")!
  const _component_MaintenanceOSConsultaPanel = _resolveComponent("MaintenanceOSConsultaPanel")!
  const _component_PreencherOSPanel = _resolveComponent("PreencherOSPanel")!
  const _component_PortariaOverviewPanel = _resolveComponent("PortariaOverviewPanel")!
  const _component_SubmissionFormView = _resolveComponent("SubmissionFormView")!
  const _component_SafetyDialogFormView = _resolveComponent("SafetyDialogFormView")!
  const _component_SafetyOccurrenceFormView = _resolveComponent("SafetyOccurrenceFormView")!
  const _component_SubmissionView = _resolveComponent("SubmissionView")!
  const _component_SafetyDocumentView = _resolveComponent("SafetyDocumentView")!
  const _component_DocumentsPanel = _resolveComponent("DocumentsPanel")!
  const _component_DrawingsPanel = _resolveComponent("DrawingsPanel")!
  const _component_UsersPanel = _resolveComponent("UsersPanel")!
  const _component_ProjectsPanel = _resolveComponent("ProjectsPanel")!
  const _component_MyProjectsPanel = _resolveComponent("MyProjectsPanel")!
  const _component_MyTasksPanel = _resolveComponent("MyTasksPanel")!
  const _component_ProjectWorkspaceView = _resolveComponent("ProjectWorkspaceView")!
  const _component_WarehouseView = _resolveComponent("WarehouseView")!
  const _component_WarehouseRequestItemView = _resolveComponent("WarehouseRequestItemView")!
  const _component_OfficePanel = _resolveComponent("OfficePanel")!
  const _component_HeavyMachineryView = _resolveComponent("HeavyMachineryView")!
  const _component_TicketsView = _resolveComponent("TicketsView")!
  const _component_ProfileEditView = _resolveComponent("ProfileEditView")!
  const _component_AnotacoesView = _resolveComponent("AnotacoesView")!
  const _component_NotificationsView = _resolveComponent("NotificationsView")!
  const _component_SystemPanel = _resolveComponent("SystemPanel")!
  const _component_ConfirmDeleteModal = _resolveComponent("ConfirmDeleteModal")!
  const _component_OnboardingWizard = _resolveComponent("OnboardingWizard")!
  const _component_NotificationsPanel = _resolveComponent("NotificationsPanel")!
  const _component_MessengerPanel = _resolveComponent("MessengerPanel")!
  const _component_WhatsNewModal = _resolveComponent("WhatsNewModal")!
  const _component_CreatePopupModal = _resolveComponent("CreatePopupModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "app-loading" }, {
      default: _withCtx(() => [
        (!_ctx.isAppReady)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[44] || (_cache[44] = [
              _createElementVNode("div", { class: "app-loading-box" }, [
                _createElementVNode("div", { class: "app-loading-spinner" }),
                _createElementVNode("span", { class: "app-loading-label" }, "Carregando…")
              ], -1)
            ]))]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.isSuspendedAdmin)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[48] || (_cache[48] = _createStaticVNode("<div class=\"suspension-header\" data-v-fddfeaa0><svg width=\"32\" height=\"32\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#92400e\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-fddfeaa0><path d=\"M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z\" data-v-fddfeaa0></path><line x1=\"12\" y1=\"9\" x2=\"12\" y2=\"13\" data-v-fddfeaa0></line><line x1=\"12\" y1=\"17\" x2=\"12.01\" y2=\"17\" data-v-fddfeaa0></line></svg><h1 class=\"suspension-title\" data-v-fddfeaa0>Esta obra esta suspensa</h1></div><p class=\"suspension-subtitle\" data-v-fddfeaa0>Seu acesso esta restrito. Para retomar as operacoes, solicite a reativacao ao administrador master.</p>", 2)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.accounts.length), 1),
                _cache[45] || (_cache[45] = _createElementVNode("span", { class: "susp-stat-label" }, "Usuarios", -1))
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.projects.length), 1),
                _cache[46] || (_cache[46] = _createElementVNode("span", { class: "susp-stat-label" }, "Projetos", -1))
              ])
            ]),
            (!_ctx.reactivationSent)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _cache[47] || (_cache[47] = _createElementVNode("label", { class: "susp-label" }, "Mensagem (opcional)", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.reactivationMessage) = $event)),
                    class: "susp-textarea",
                    rows: "3",
                    placeholder: "Descreva o motivo da solicitacao..."
                  }, null, 512), [
                    [_vModelText, _ctx.reactivationMessage]
                  ]),
                  (_ctx.reactivationError)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.reactivationError), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "susp-btn",
                    type: "button",
                    disabled: _ctx.reactivationLoading,
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submitReactivation && _ctx.submitReactivation(...args)))
                  }, _toDisplayString(_ctx.reactivationLoading ? 'Enviando...' : 'Solicitar Reativacao'), 9, _hoisted_12)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_13, " Solicitacao enviada com sucesso! Aguarde o contato do administrador. ")),
            _createElementVNode("button", {
              class: "susp-logout",
              type: "button",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
            }, "Sair")
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isSystemSaving)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[49] || (_cache[49] = [
          _createElementVNode("div", { class: "saving-card" }, "Salvando alteracoes...", -1)
        ]))]))
      : _createCommentVNode("", true),
    _createVNode(_component_DashboardNavbar, {
      "site-name": _ctx.siteName,
      "site-logo-url": _ctx.siteLogoUrl,
      "search-query": _ctx.searchQuery,
      "user-name": _ctx.userName,
      "user-avatar": _ctx.userAvatar,
      "notification-count": _ctx.unreadNotifications,
      "show-menu-button": _ctx.isNarrowScreen,
      "menu-open": _ctx.mobileMenuOpen,
      "logo-text": _ctx.logoText,
      "user-username": _ctx.currentUsername,
      "ia-mode": false,
      "show-ia-button": _ctx.showIaButton,
      onToggleMenu: _ctx.toggleMobileMenu,
      onSearchChange: _ctx.onSearchChange,
      onProfile: _ctx.goProfile,
      onLogout: _ctx.logout,
      onNotifications: _ctx.toggleNotifications,
      onWhatsNew: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showWhatsNew = true)),
      onIaMode: _cache[4] || (_cache[4] = ($event: any) => (_ctx.router.push('/ia'))),
      onAnotacoes: _cache[5] || (_cache[5] = ($event: any) => (_ctx.router.push('/anotacoes')))
    }, null, 8, ["site-name", "site-logo-url", "search-query", "user-name", "user-avatar", "notification-count", "show-menu-button", "menu-open", "logo-text", "user-username", "show-ia-button", "onToggleMenu", "onSearchChange", "onProfile", "onLogout", "onNotifications"]),
    (_ctx.showStorageAlert)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(["storage-alert-banner", _ctx.storageAlertPct >= 90 ? 'storage-alert-critical' : 'storage-alert-warn'])
        }, [
          _cache[51] || (_cache[51] = _createElementVNode("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            _createElementVNode("path", { d: "M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" }),
            _createElementVNode("line", {
              x1: "12",
              y1: "9",
              x2: "12",
              y2: "13"
            }),
            _createElementVNode("line", {
              x1: "12",
              y1: "17",
              x2: "12.01",
              y2: "17"
            })
          ], -1)),
          _createElementVNode("span", null, [
            _cache[50] || (_cache[50] = _createTextVNode("Armazenamento: ", -1)),
            _createElementVNode("strong", null, _toDisplayString(_ctx.storageAlertPct) + "%", 1),
            _createTextVNode(" utilizado (" + _toDisplayString(_ctx.storageAlertMb.toFixed(1)) + " MB / " + _toDisplayString(_ctx.storageAlertLimit) + " MB). " + _toDisplayString(_ctx.storageAlertPct >= 90 ? 'Limite crítico!' : 'Considere limpar arquivos antigos.'), 1)
          ]),
          _createElementVNode("button", {
            class: "storage-alert-dismiss",
            type: "button",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.storageAlertDismissed = true))
          }, "✕")
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_Transition, { name: "backdrop-fade" }, {
        default: _withCtx(() => [
          (_ctx.isNarrowScreen && _ctx.mobileMenuOpen)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "mobile-sidebar-backdrop",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.toggleMobileMenu && _ctx.toggleMobileMenu(...args)))
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createElementVNode("div", {
        class: _normalizeClass(["sidebar-shell", { open: !_ctx.isNarrowScreen || _ctx.mobileMenuOpen }])
      }, [
        _createVNode(_component_DashboardSidebar, {
          "user-name": _ctx.userName,
          "system-name": _ctx.siteName,
          "is-admin": _ctx.isAdmin,
          "is-master-admin": _ctx.isMasterAdmin,
          "is-analyst": _ctx.isAnalyst,
          "can-manage-warehouse": _ctx.canManageWarehouse,
          "can-request-warehouse": _ctx.canRequestWarehouse,
          "active-path": _ctx.normalizedActivePath,
          "current-mode": _ctx.currentMode,
          "has-subordinates": _ctx.hasSubordinates,
          "show-search": _ctx.isNarrowScreen,
          "search-query": _ctx.searchQuery,
          "ticket-pending-count": _ctx.ticketPendingCount,
          "messenger-unread": _ctx.messengerStore.state.unreadTotal,
          "project-name": _ctx.panel === 'projectWorkspace' ? _ctx.panelTitle : '',
          "panel-title": _ctx.panel !== 'projectWorkspace' ? _ctx.panelTitle : '',
          "maintenance-enabled": Boolean(_ctx.systemStore.state.config.maintenanceEnabled || _ctx.systemForm.maintenanceEnabled),
          "can-manage-construction": _ctx.canManageConstruction,
          "can-manage-maintenance": _ctx.canManageMaintenance,
          "can-assign-maintenance": _ctx.maintenanceAccessLevel >= 2,
          "can-manage-office": _ctx.canManageOffice,
          "can-manage-portaria": _ctx.canManagePortaria,
          "show-tickets": _ctx.showTickets,
          onMessenger: _ctx.toggleMessenger,
          onOpenCreatePopup: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showCreatePopup = true)),
          onStartReport: _ctx.startReport,
          onDialogo: _ctx.goDialogo,
          onPermissao: _ctx.goPermissao,
          onOcorrido: _ctx.goOcorrido,
          onOverview: _ctx.openOverview,
          onDocuments: _ctx.openDocuments,
          onProjects: _ctx.openProjects,
          onUsers: _ctx.openUsers,
          onSystem: _ctx.openSystem,
          onMyProjects: _ctx.openMyProjects,
          onMyTasks: _ctx.openMyTasks,
          onDrawings: _ctx.openDrawings,
          onWarehouseStock: _ctx.openWarehouseStock,
          onWarehouseRequests: _ctx.openWarehouseRequests,
          onWarehousePlanejamento: _ctx.openWarehousePlanejamento,
          onWarehouseAvarias: _ctx.openWarehouseAvarias,
          onWarehouseNfeImport: _ctx.openWarehouseNfeImport,
          onWarehouseRequestItem: _ctx.openWarehouseRequestItem,
          onHeavyMachinery: _ctx.openHeavyMachinery,
          "warehouse-tab": _ctx.warehouseTab,
          onTickets: _ctx.openTickets,
          onActivityLog: _ctx.openActivityLog,
          onFilter: _ctx.setFilter,
          onSearchChange: _ctx.onSearchChange,
          onSearchSubmit: _ctx.onSearchSubmit,
          onStartAtividade: _ctx.openAtividadeModal,
          onStartPendencia: _ctx.openPendenciaModal,
          onMaintenance: _ctx.openMaintenance,
          onMaintenanceManuals: _ctx.openMaintenanceManuals,
          onMaintenanceServiceOrders: _ctx.openMaintenanceServiceOrders,
          onMaintenanceOsConsulta: _ctx.openMaintenanceOSConsulta,
          onGoGeral: _ctx.openGeral,
          onGoAdminMode: _ctx.openAdminMode,
          onGoWarehouse: _ctx.openWarehouseMode,
          onGoOffice: _ctx.openOfficeMode,
          onGoPortaria: _ctx.openPortariaMode,
          onOfficeTab: _ctx.setOfficeTab,
          "office-tab": _ctx.officeTab
        }, null, 8, ["user-name", "system-name", "is-admin", "is-master-admin", "is-analyst", "can-manage-warehouse", "can-request-warehouse", "active-path", "current-mode", "has-subordinates", "show-search", "search-query", "ticket-pending-count", "messenger-unread", "project-name", "panel-title", "maintenance-enabled", "can-manage-construction", "can-manage-maintenance", "can-assign-maintenance", "can-manage-office", "can-manage-portaria", "show-tickets", "onMessenger", "onStartReport", "onDialogo", "onPermissao", "onOcorrido", "onOverview", "onDocuments", "onProjects", "onUsers", "onSystem", "onMyProjects", "onMyTasks", "onDrawings", "onWarehouseStock", "onWarehouseRequests", "onWarehousePlanejamento", "onWarehouseAvarias", "onWarehouseNfeImport", "onWarehouseRequestItem", "onHeavyMachinery", "warehouse-tab", "onTickets", "onActivityLog", "onFilter", "onSearchChange", "onSearchSubmit", "onStartAtividade", "onStartPendencia", "onMaintenance", "onMaintenanceManuals", "onMaintenanceServiceOrders", "onMaintenanceOsConsulta", "onGoGeral", "onGoAdminMode", "onGoWarehouse", "onGoOffice", "onGoPortaria", "onOfficeTab", "office-tab"])
      ], 2),
      _createElementVNode("main", {
        class: _normalizeClass(["content", { 'workspace-mode': _ctx.panel === 'projectWorkspace', 'profile-mode': _ctx.panel === 'profilePanel', 'maintenance-mode': _ctx.panel === 'maintenancePanel' || _ctx.panel === 'maintenanceProjectPanel' || _ctx.panel === 'maintenanceManualsPanel', 'form-mode': _ctx.panel === 'reportForm' || _ctx.panel === 'dialogForm' || _ctx.panel === 'occurrenceForm' }])
      }, [
        (_ctx.panel === 'overview')
          ? (_openBlock(), _createBlock(_component_OverviewPanel, {
              key: 0,
              projects: _ctx.projects,
              "project-insights": _ctx.projectInsights,
              accounts: _ctx.accounts,
              "format-report-date": _ctx.formatReportDate,
              onRefresh: _ctx.refreshAllData,
              onExtendProject: _ctx.extendProject
            }, null, 8, ["projects", "project-insights", "accounts", "format-report-date", "onRefresh", "onExtendProject"]))
          : (_ctx.panel === 'list')
            ? (_openBlock(), _createBlock(_component_ReportsPanel, {
                key: 1,
                "filter-type": _ctx.filterType,
                "user-filter": _ctx.userFilter,
                "user-options": _ctx.userOptions,
                "date-from": _ctx.dateFrom,
                "date-to": _ctx.dateTo,
                "all-types": _ctx.allTypes,
                "selected-items": _ctx.selectedReports,
                "filtered-items": _ctx.filteredItems,
                "format-report-date": _ctx.formatReportDate,
                "activities-text": _ctx.activitiesText,
                onSetFilterType: _cache[9] || (_cache[9] = ($event: any) => (_ctx.filterType = $event)),
                onSetUserFilter: _cache[10] || (_cache[10] = ($event: any) => (_ctx.userFilter = $event)),
                onSetDateFrom: _cache[11] || (_cache[11] = ($event: any) => (_ctx.dateFrom = $event)),
                onSetDateTo: _cache[12] || (_cache[12] = ($event: any) => (_ctx.dateTo = $event)),
                onToggleCreate: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showCreatePopup = true)),
                onExportDocs: _ctx.exportSelectedReportsAsDoc,
                onExportPdfs: _ctx.exportSelectedReportsAsPdf,
                onDeleteDocs: _ctx.askDeleteSelectedReports,
                onToggleItem: _ctx.toggleReportSelection,
                onView: _ctx.openView,
                onEdit: _ctx.openEdit
              }, null, 8, ["filter-type", "user-filter", "user-options", "date-from", "date-to", "all-types", "selected-items", "filtered-items", "format-report-date", "activities-text", "onExportDocs", "onExportPdfs", "onDeleteDocs", "onToggleItem", "onView", "onEdit"]))
            : (_ctx.panel === 'maintenancePanel')
              ? (_openBlock(), _createBlock(_component_MaintenanceOverviewPanel, {
                  key: 2,
                  "is-admin": _ctx.isAdmin,
                  "access-level": _ctx.maintenanceAccessLevel
                }, null, 8, ["is-admin", "access-level"]))
              : (_ctx.panel === 'maintenanceProjectPanel' && _ctx.maintenanceProject)
                ? (_openBlock(), _createBlock(_component_MaintenanceProjectPanel, {
                    key: 3,
                    project: _ctx.maintenanceProject,
                    "is-admin": _ctx.isAdmin,
                    "access-level": _ctx.maintenanceAccessLevel,
                    onBack: _ctx.openMaintenance
                  }, null, 8, ["project", "is-admin", "access-level", "onBack"]))
                : (_ctx.panel === 'maintenanceManualsPanel')
                  ? (_openBlock(), _createBlock(_component_MaintenanceManualsPanel, {
                      key: 4,
                      "is-admin": _ctx.isAdmin
                    }, null, 8, ["is-admin"]))
                  : (_ctx.panel === 'maintenanceServiceOrdersPanel')
                    ? (_openBlock(), _createBlock(_component_MaintenanceServiceOrdersPanel, {
                        key: 5,
                        "access-level": _ctx.maintenanceAccessLevel
                      }, null, 8, ["access-level"]))
                    : (_ctx.panel === 'maintenanceOSConsultaPanel')
                      ? (_openBlock(), _createBlock(_component_MaintenanceOSConsultaPanel, { key: 6 }))
                      : (_ctx.panel === 'preencherOSPanel')
                        ? (_openBlock(), _createBlock(_component_PreencherOSPanel, { key: 7 }))
                        : (_ctx.panel === 'portariaPanel')
                          ? (_openBlock(), _createBlock(_component_PortariaOverviewPanel, {
                              key: 8,
                              "access-level": _ctx.portariaAccessLevel
                            }, null, 8, ["access-level"]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              (_ctx.panel === 'projects' || (_ctx.panel !== 'projectWorkspace' && _ctx.panel !== 'documents' && _ctx.panel !== 'drawings' && _ctx.panel !== 'users' && _ctx.panel !== 'system' && _ctx.panel !== 'warehousePanel' && _ctx.panel !== 'warehouseRequestPanel' && _ctx.panel !== 'heavyMachineryPanel' && _ctx.panel !== 'ticketsPanel' && _ctx.panel !== 'profilePanel' && _ctx.panel !== 'officePanel' && _ctx.panel !== 'anotacoesPanel' && _ctx.panel !== 'reportForm' && _ctx.panel !== 'dialogForm' && _ctx.panel !== 'occurrenceForm'))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [...(_cache[52] || (_cache[52] = [
                                    _createElementVNode("div", { class: "actions" }, null, -1)
                                  ]))]))
                                : _createCommentVNode("", true),
                              (_ctx.panel === 'reportForm')
                                ? (_openBlock(), _createBlock(_component_SubmissionFormView, {
                                    key: 1,
                                    embedded: true,
                                    "submission-id": _ctx.activeId,
                                    "prefill-type": _ctx.prefillType,
                                    onDone: _ctx.backToList,
                                    onCancel: _ctx.backToList,
                                    onEdit: _ctx.openEdit
                                  }, null, 8, ["submission-id", "prefill-type", "onDone", "onCancel", "onEdit"]))
                                : (_ctx.panel === 'dialogForm')
                                  ? (_openBlock(), _createBlock(_component_SafetyDialogFormView, {
                                      key: 2,
                                      embedded: true,
                                      "submission-id": _ctx.activeId,
                                      onDone: _ctx.backToList,
                                      onCancel: _ctx.backToList
                                    }, null, 8, ["submission-id", "onDone", "onCancel"]))
                                  : (_ctx.panel === 'occurrenceForm')
                                    ? (_openBlock(), _createBlock(_component_SafetyOccurrenceFormView, {
                                        key: 3,
                                        embedded: true,
                                        "submission-id": _ctx.activeId,
                                        onDone: _ctx.backToList,
                                        onCancel: _ctx.backToList
                                      }, null, 8, ["submission-id", "onDone", "onCancel"]))
                                    : (_ctx.panel === 'reportView')
                                      ? (_openBlock(), _createBlock(_component_SubmissionView, {
                                          key: 4,
                                          embedded: true,
                                          "submission-id": _ctx.activeId,
                                          onBack: _ctx.backToList,
                                          onEdit: _ctx.openEdit
                                        }, null, 8, ["submission-id", "onBack", "onEdit"]))
                                      : (_ctx.panel === 'safetyView')
                                        ? (_openBlock(), _createBlock(_component_SafetyDocumentView, {
                                            key: 5,
                                            embedded: true,
                                            "submission-id": _ctx.activeId,
                                            onBack: _ctx.backToList,
                                            onEdit: _ctx.openEdit
                                          }, null, 8, ["submission-id", "onBack", "onEdit"]))
                                        : (_ctx.panel === 'documents')
                                          ? (_openBlock(), _createBlock(_component_DocumentsPanel, {
                                              key: 6,
                                              "all-types": _ctx.allTypes,
                                              "doc-filter-type": _ctx.docFilterType,
                                              "doc-user-filter": _ctx.docUserFilter,
                                              "doc-date-from": _ctx.docDateFrom,
                                              "doc-date-to": _ctx.docDateTo,
                                              "doc-user-options": _ctx.docUserOptions,
                                              "selected-docs": _ctx.selectedDocs,
                                              "documents-items": _ctx.documentsItems,
                                              "format-report-date": _ctx.formatReportDate,
                                              "activities-text": _ctx.activitiesText,
                                              onSetDocType: _cache[14] || (_cache[14] = ($event: any) => (_ctx.docFilterType = $event)),
                                              onSetDocUser: _cache[15] || (_cache[15] = ($event: any) => (_ctx.docUserFilter = $event)),
                                              onSetDocDateFrom: _cache[16] || (_cache[16] = ($event: any) => (_ctx.docDateFrom = $event)),
                                              onSetDocDateTo: _cache[17] || (_cache[17] = ($event: any) => (_ctx.docDateTo = $event)),
                                              onExportDocs: _ctx.exportSelectedDocsAsDoc,
                                              onExportPdfs: _ctx.exportSelectedDocsAsPdf,
                                              onDeleteDocs: _ctx.askDeleteSelectedDocs,
                                              onToggleDoc: _ctx.toggleDoc,
                                              onView: _ctx.openView,
                                              onEdit: _ctx.openEdit
                                            }, null, 8, ["all-types", "doc-filter-type", "doc-user-filter", "doc-date-from", "doc-date-to", "doc-user-options", "selected-docs", "documents-items", "format-report-date", "activities-text", "onExportDocs", "onExportPdfs", "onDeleteDocs", "onToggleDoc", "onView", "onEdit"]))
                                          : (_ctx.panel === 'drawings')
                                            ? (_openBlock(), _createBlock(_component_DrawingsPanel, {
                                                key: 7,
                                                projects: _ctx.projects
                                              }, null, 8, ["projects"]))
                                            : (_ctx.panel === 'users')
                                              ? (_openBlock(), _createBlock(_component_UsersPanel, {
                                                  key: 8,
                                                  accounts: _ctx.accounts,
                                                  "current-uid": _ctx.currentUid,
                                                  "current-user-role": _ctx.sessionUserRole,
                                                  "show-account-form": _ctx.showAccountForm,
                                                  "account-form": _ctx.accountForm,
                                                  "account-error": _ctx.accountError,
                                                  roles: _ctx.roles,
                                                  "show-role-form": _ctx.showRoleForm,
                                                  "role-form": _ctx.roleForm,
                                                  "role-error": _ctx.roleError,
                                                  "offline-employees": _ctx.offlineEmployees,
                                                  "show-offline-employee-form": _ctx.showOfflineEmployeeForm,
                                                  "offline-employee-form": _ctx.offlineEmployeeForm,
                                                  "offline-employee-error": _ctx.offlineEmployeeError,
                                                  "account-subordinate-options": _ctx.accountSubordinateOptions,
                                                  "is-analyst": _ctx.isAnalyst,
                                                  onRefreshAccounts: _ctx.refreshAccounts,
                                                  onOpenAccountForm: _ctx.openAccountForm,
                                                  onEditAccount: _ctx.editAccount,
                                                  onDeleteAccount: _ctx.askDeleteAccount,
                                                  onSaveAccount: _ctx.saveAccount,
                                                  onCloseAccountForm: _ctx.closeAccountForm,
                                                  onUpdateAccountForm: _ctx.onAccountFormUpdate,
                                                  onAddAccountSubordinate: _ctx.addAccountSubordinate,
                                                  onRemoveAccountSubordinate: _ctx.removeAccountSubordinate,
                                                  onRefreshRoles: _ctx.refreshRoles,
                                                  onOpenRoleForm: _ctx.openRoleForm,
                                                  onEditRole: _ctx.editRole,
                                                  onSaveRole: _ctx.saveRole,
                                                  onCloseRoleForm: _ctx.closeRoleForm,
                                                  onAddRoleSubordinate: _ctx.addRoleSubordinate,
                                                  onRemoveRoleSubordinate: _ctx.removeRoleSubordinate,
                                                  onUpdateRoleForm: _ctx.onRoleFormUpdate,
                                                  onOpenOfflineEmployeeForm: _ctx.openOfflineEmployeeForm,
                                                  onCloseOfflineEmployeeForm: _ctx.closeOfflineEmployeeForm,
                                                  onSaveOfflineEmployee: _ctx.saveOfflineEmployee,
                                                  onEditOfflineEmployee: _ctx.editOfflineEmployee,
                                                  onDeleteOfflineEmployee: _ctx.askDeleteOfflineEmployee,
                                                  onUpdateOfflineEmployeeForm: _ctx.onOfflineEmployeeFormUpdate
                                                }, null, 8, ["accounts", "current-uid", "current-user-role", "show-account-form", "account-form", "account-error", "roles", "show-role-form", "role-form", "role-error", "offline-employees", "show-offline-employee-form", "offline-employee-form", "offline-employee-error", "account-subordinate-options", "is-analyst", "onRefreshAccounts", "onOpenAccountForm", "onEditAccount", "onDeleteAccount", "onSaveAccount", "onCloseAccountForm", "onUpdateAccountForm", "onAddAccountSubordinate", "onRemoveAccountSubordinate", "onRefreshRoles", "onOpenRoleForm", "onEditRole", "onSaveRole", "onCloseRoleForm", "onAddRoleSubordinate", "onRemoveRoleSubordinate", "onUpdateRoleForm", "onOpenOfflineEmployeeForm", "onCloseOfflineEmployeeForm", "onSaveOfflineEmployee", "onEditOfflineEmployee", "onDeleteOfflineEmployee", "onUpdateOfflineEmployeeForm"]))
                                              : (_ctx.panel === 'projects')
                                                ? (_openBlock(), _createBlock(_component_ProjectsPanel, {
                                                    key: 9,
                                                    projects: _ctx.projects,
                                                    "project-mode": _ctx.projectMode,
                                                    "selected-project": _ctx.selectedProject,
                                                    "project-form": _ctx.projectForm,
                                                    "project-error": _ctx.projectError,
                                                    accounts: _ctx.accounts,
                                                    "format-report-date": _ctx.formatReportDate,
                                                    "is-analyst": _ctx.isAnalyst,
                                                    onViewProject: _ctx.viewProject,
                                                    onEditProject: _ctx.editProject,
                                                    onDeleteProject: _ctx.askDeleteProject,
                                                    onCloseProjectMode: _ctx.closeProjectMode,
                                                    onSaveProject: _ctx.saveProject,
                                                    onUpdateProjectForm: _ctx.onProjectFormUpdate,
                                                    onAddResponsible: _ctx.addResponsibleUser,
                                                    onRemoveResponsible: _ctx.removeResponsibleUser
                                                  }, null, 8, ["projects", "project-mode", "selected-project", "project-form", "project-error", "accounts", "format-report-date", "is-analyst", "onViewProject", "onEditProject", "onDeleteProject", "onCloseProjectMode", "onSaveProject", "onUpdateProjectForm", "onAddResponsible", "onRemoveResponsible"]))
                                                : (_ctx.panel === 'myProjects')
                                                  ? (_openBlock(), _createBlock(_component_MyProjectsPanel, {
                                                      key: 10,
                                                      projects: _ctx.projects,
                                                      "project-insights": _ctx.projectInsights,
                                                      accounts: _ctx.accounts,
                                                      "project-mode": _ctx.projectMode,
                                                      "project-form": _ctx.projectForm,
                                                      "project-error": _ctx.projectError,
                                                      "selected-project": _ctx.selectedProject,
                                                      "is-admin": _ctx.isAdmin,
                                                      "current-username": _ctx.currentUsername,
                                                      "subordinate-options": _ctx.subordinateOptions,
                                                      "format-report-date": _ctx.formatReportDate,
                                                      onViewProject: _ctx.viewProject,
                                                      onExtendProject: _ctx.extendProject,
                                                      onEditProject: _ctx.editProject,
                                                      onCloseProjectMode: _ctx.closeProjectMode,
                                                      onSaveProject: _ctx.saveProject,
                                                      onUpdateProjectForm: _ctx.onProjectFormUpdate,
                                                      onAddResponsible: _ctx.addResponsibleUser,
                                                      onRemoveResponsible: _ctx.removeResponsibleUser,
                                                      onAddTempResponsible: _ctx.addTempResponsible,
                                                      onRemoveTempResponsible: _ctx.removeTempResponsible,
                                                      onUpdateTempResponsible: _ctx.updateTempResponsible
                                                    }, null, 8, ["projects", "project-insights", "accounts", "project-mode", "project-form", "project-error", "selected-project", "is-admin", "current-username", "subordinate-options", "format-report-date", "onViewProject", "onExtendProject", "onEditProject", "onCloseProjectMode", "onSaveProject", "onUpdateProjectForm", "onAddResponsible", "onRemoveResponsible", "onAddTempResponsible", "onRemoveTempResponsible", "onUpdateTempResponsible"]))
                                                  : (_ctx.panel === 'myTasks')
                                                    ? (_openBlock(), _createBlock(_component_MyTasksPanel, {
                                                        key: 11,
                                                        projects: _ctx.projects,
                                                        "current-username": _ctx.currentUsername,
                                                        accounts: _ctx.accounts,
                                                        onViewProject: _ctx.viewProject
                                                      }, null, 8, ["projects", "current-username", "accounts", "onViewProject"]))
                                                    : (_ctx.panel === 'projectWorkspace')
                                                      ? (_openBlock(), _createBlock(_component_ProjectWorkspaceView, {
                                                          key: 12,
                                                          embedded: true,
                                                          "project-id": _ctx.selectedProjectId,
                                                          "is-analyst": _ctx.isAnalyst,
                                                          "system-name": _ctx.siteName,
                                                          "logo-text": _ctx.logoText,
                                                          onBack: _ctx.backToProjectsPanel
                                                        }, null, 8, ["project-id", "is-analyst", "system-name", "logo-text", "onBack"]))
                                                      : (_ctx.panel === 'warehousePanel')
                                                        ? (_openBlock(), _createBlock(_component_WarehouseView, {
                                                            key: 13,
                                                            "is-analyst": _ctx.isAnalyst
                                                          }, null, 8, ["is-analyst"]))
                                                        : (_ctx.panel === 'warehouseRequestPanel')
                                                          ? (_openBlock(), _createBlock(_component_WarehouseRequestItemView, { key: 14 }))
                                                          : (_ctx.panel === 'officePanel')
                                                            ? (_openBlock(), _createBlock(_component_OfficePanel, {
                                                                key: 15,
                                                                "active-tab": _ctx.officeTab,
                                                                onTabChange: _ctx.setOfficeTab
                                                              }, null, 8, ["active-tab", "onTabChange"]))
                                                            : (_ctx.panel === 'heavyMachineryPanel')
                                                              ? (_openBlock(), _createBlock(_component_HeavyMachineryView, {
                                                                  key: 16,
                                                                  "is-analyst": _ctx.isAnalyst
                                                                }, null, 8, ["is-analyst"]))
                                                              : (_ctx.panel === 'ticketsPanel')
                                                                ? (_openBlock(), _createBlock(_component_TicketsView, { key: 17 }))
                                                                : (_ctx.panel === 'profilePanel')
                                                                  ? (_openBlock(), _createBlock(_component_ProfileEditView, {
                                                                      key: 18,
                                                                      "in-panel": true,
                                                                      onDone: _cache[18] || (_cache[18] = ($event: any) => (_ctx.panel = 'overview'))
                                                                    }))
                                                                  : (_ctx.panel === 'anotacoesPanel')
                                                                    ? (_openBlock(), _createBlock(_component_AnotacoesView, {
                                                                        key: 19,
                                                                        embedded: true
                                                                      }))
                                                                    : (_ctx.panel === 'notificationsPanel')
                                                                      ? (_openBlock(), _createBlock(_component_NotificationsView, {
                                                                          key: 20,
                                                                          embedded: true
                                                                        }))
                                                                      : (_ctx.panel === 'system')
                                                                        ? (_openBlock(), _createBlock(_component_SystemPanel, {
                                                                            key: 21,
                                                                            form: _ctx.systemForm,
                                                                            "error-text": _ctx.systemError,
                                                                            "success-text": _ctx.systemSuccess,
                                                                            "initial-tab": _ctx.systemTab,
                                                                            "is-master-admin": _ctx.isMasterAdmin,
                                                                            onUpdateForm: _ctx.updateSystemForm,
                                                                            onSave: _ctx.saveSystem
                                                                          }, null, 8, ["form", "error-text", "success-text", "initial-tab", "is-master-admin", "onUpdateForm", "onSave"]))
                                                                        : (_openBlock(), _createElementBlock("div", _hoisted_18, [...(_cache[53] || (_cache[53] = [
                                                                            _createElementVNode("h3", { class: "item-title" }, "Problema seu", -1)
                                                                          ]))]))
                            ]))
      ], 2)
    ]),
    _createVNode(_component_ConfirmDeleteModal, {
      open: _ctx.confirmDeleteOpen,
      label: _ctx.confirmDeleteLabel,
      saving: _ctx.confirmDeleteSaving,
      onConfirm: _ctx.confirmDelete,
      onCancel: _ctx.cancelDelete
    }, null, 8, ["open", "label", "saving", "onConfirm", "onCancel"]),
    (_ctx.showOnboarding)
      ? (_openBlock(), _createBlock(_component_OnboardingWizard, {
          key: 3,
          "system-name": _ctx.siteName,
          "has-project": _ctx.projects.length > 0,
          "has-user": _ctx.accounts.length > 1,
          onDismiss: _ctx.dismissOnboarding,
          onGoTo: _ctx.onboardingGoTo
        }, null, 8, ["system-name", "has-project", "has-user", "onDismiss", "onGoTo"]))
      : _createCommentVNode("", true),
    (_ctx.showNotifications)
      ? (_openBlock(), _createBlock(_component_NotificationsPanel, {
          key: 4,
          notifications: _ctx.notifications,
          onClose: _ctx.toggleNotifications,
          onOpenNotification: _ctx.openNotification,
          onViewAll: _ctx.goToAllNotifications
        }, null, 8, ["notifications", "onClose", "onOpenNotification", "onViewAll"]))
      : _createCommentVNode("", true),
    (_ctx.ddsConfirmOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _cache[54] || (_cache[54] = _createElementVNode("h3", null, "Confirmacao de Presenca DDS", -1)),
            _createElementVNode("p", _hoisted_21, " Voce confirma presenca no DDS \"" + _toDisplayString(_ctx.ddsConfirmName) + "\"? ", 1),
            _createElementVNode("video", _hoisted_22, null, 512),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("button", {
                class: "btn btn-ghost",
                type: "button",
                onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.startDdsCamera && _ctx.startDdsCamera(...args)))
              }, "Ativar camera"),
              _createElementVNode("button", {
                class: "btn btn-secondary",
                type: "button",
                onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.captureDdsPhoto && _ctx.captureDdsPhoto(...args)))
              }, "Capturar foto"),
              _createElementVNode("button", {
                class: "btn btn-primary",
                type: "button",
                onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.confirmDdsPresence && _ctx.confirmDdsPresence(...args)))
              }, "Confirmar"),
              _createElementVNode("button", {
                class: "btn btn-accent",
                type: "button",
                onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.closeDdsConfirm && _ctx.closeDdsConfirm(...args)))
              }, "Cancelar")
            ]),
            (_ctx.ddsPhotoDataUrl)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "dds-preview",
                  src: _ctx.ddsPhotoDataUrl,
                  alt: "preview camera"
                }, null, 8, _hoisted_24))
              : _createCommentVNode("", true),
            (_ctx.ddsConfirmError)
              ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(_ctx.ddsConfirmError), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_MessengerPanel, {
      open: _ctx.messengerOpen,
      "current-username": _ctx.currentUsername,
      "current-system-id": _ctx.currentSystemId,
      onClose: _cache[23] || (_cache[23] = ($event: any) => (_ctx.messengerOpen = false))
    }, null, 8, ["open", "current-username", "current-system-id"]),
    (_ctx.showWhatsNew)
      ? (_openBlock(), _createBlock(_component_WhatsNewModal, {
          key: 6,
          onClose: _ctx.closeWhatsNew
        }, null, 8, ["onClose"]))
      : _createCommentVNode("", true),
    _createVNode(_component_CreatePopupModal, {
      open: _ctx.showCreatePopup,
      "current-mode": _ctx.currentMode,
      "is-admin": _ctx.isAdmin,
      "can-manage-construction": _ctx.canManageConstruction,
      "can-manage-maintenance": _ctx.canManageMaintenance,
      "can-manage-warehouse": _ctx.canManageWarehouse,
      "can-manage-office": _ctx.canManageOffice,
      onClose: _cache[24] || (_cache[24] = ($event: any) => (_ctx.showCreatePopup = false)),
      onAction: _ctx.handleCreateAction
    }, null, 8, ["open", "current-mode", "is-admin", "can-manage-construction", "can-manage-maintenance", "can-manage-warehouse", "can-manage-office", "onAction"]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.showAtividadeModal)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "quick-modal-overlay",
            onClick: _cache[27] || (_cache[27] = _withModifiers(($event: any) => (_ctx.showAtividadeModal = false), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _cache[55] || (_cache[55] = _createElementVNode("h3", { class: "quick-modal-title" }, "Criar atividade", -1)),
                _createElementVNode("button", {
                  class: "quick-modal-close",
                  type: "button",
                  onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.showAtividadeModal = false))
                }, "✕")
              ]),
              _createElementVNode("div", _hoisted_28, [
                _cache[57] || (_cache[57] = _createElementVNode("p", { class: "quick-modal-sub" }, "Selecione o projeto onde a atividade será criada:", -1)),
                _createElementVNode("div", _hoisted_29, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (p) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: p.id,
                      class: "quick-project-btn",
                      type: "button",
                      onClick: ($event: any) => (_ctx.goCreateAtividade(p.id))
                    }, [
                      _cache[56] || (_cache[56] = _createElementVNode("svg", {
                        width: "14",
                        height: "14",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2"
                      }, [
                        _createElementVNode("rect", {
                          x: "3",
                          y: "3",
                          width: "18",
                          height: "18",
                          rx: "2"
                        }),
                        _createElementVNode("path", { d: "M3 9h18M9 21V9" })
                      ], -1)),
                      _createTextVNode(" " + _toDisplayString(p.name), 1)
                    ], 8, _hoisted_30))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("button", {
                  class: "btn btn-ghost",
                  type: "button",
                  onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.showAtividadeModal = false))
                }, "Cancelar")
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.showPendenciaModal)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "quick-modal-overlay",
            onClick: _cache[43] || (_cache[43] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closePendenciaModal && _ctx.closePendenciaModal(...args)), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _cache[58] || (_cache[58] = _createElementVNode("h3", { class: "quick-modal-title" }, "Registrar pendência", -1)),
                _createElementVNode("button", {
                  class: "quick-modal-close",
                  type: "button",
                  onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.closePendenciaModal && _ctx.closePendenciaModal(...args)))
                }, "✕")
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _cache[60] || (_cache[60] = _createElementVNode("label", { class: "quick-form-label" }, [
                    _createTextVNode("Projeto "),
                    _createElementVNode("span", { class: "quick-required" }, "*")
                  ], -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.pendenciaForm.projectId) = $event)),
                    class: "quick-form-input",
                    onChange: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.onPendenciaProjectChange && _ctx.onPendenciaProjectChange(...args)))
                  }, [
                    _cache[59] || (_cache[59] = _createElementVNode("option", { value: "" }, "Selecione um projeto", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (p) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: p.id,
                        value: p.id
                      }, _toDisplayString(p.name), 9, _hoisted_36))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.pendenciaForm.projectId]
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _cache[62] || (_cache[62] = _createElementVNode("label", { class: "quick-form-label" }, "Responsável", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.pendenciaForm.responsavel) = $event)),
                    class: "quick-form-select"
                  }, [
                    _cache[61] || (_cache[61] = _createElementVNode("option", { value: "" }, "Selecione o responsável", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accounts, (u) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: u.uid,
                        value: u.name
                      }, _toDisplayString(u.name), 9, _hoisted_38))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.pendenciaForm.responsavel]
                  ])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _cache[63] || (_cache[63] = _createElementVNode("label", { class: "quick-form-label" }, [
                    _createTextVNode("Descrição curta "),
                    _createElementVNode("span", { class: "quick-required" }, "*")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.pendenciaForm.shortDescription) = $event)),
                    class: "quick-form-input",
                    type: "text",
                    placeholder: "Resumo da pendência"
                  }, null, 512), [
                    [_vModelText, _ctx.pendenciaForm.shortDescription]
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _cache[64] || (_cache[64] = _createElementVNode("label", { class: "quick-form-label" }, "Descrição completa", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.pendenciaForm.fullDescription) = $event)),
                    class: "quick-form-input quick-form-textarea",
                    rows: "3",
                    placeholder: "Detalhes, contexto, ações necessárias…"
                  }, null, 512), [
                    [_vModelText, _ctx.pendenciaForm.fullDescription]
                  ])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _cache[67] || (_cache[67] = _createElementVNode("label", { class: "quick-form-label" }, "Foto (opcional)", -1)),
                  _createElementVNode("div", {
                    class: _normalizeClass(["quick-image-grid", { 'is-drag-over': _ctx.pendenciaPhotoDragOver }]),
                    onDragenter: _cache[36] || (_cache[36] = _withModifiers(($event: any) => (_ctx.pendenciaPhotoDragOver = true), ["prevent"])),
                    onDragover: _cache[37] || (_cache[37] = _withModifiers(($event: any) => (_ctx.pendenciaPhotoDragOver = true), ["prevent"])),
                    onDragleave: _cache[38] || (_cache[38] = _withModifiers(($event: any) => (_ctx.pendenciaPhotoDragOver = false), ["prevent"])),
                    onDrop: _cache[39] || (_cache[39] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onPendenciaPhotoDrop && _ctx.onPendenciaPhotoDrop(...args)), ["prevent"]))
                  }, [
                    (_ctx.pendenciaForm.photo)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                          _createElementVNode("img", {
                            src: _ctx.pendenciaForm.photo,
                            alt: "Preview"
                          }, null, 8, _hoisted_43),
                          _createElementVNode("button", {
                            type: "button",
                            class: "quick-image-remove",
                            onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.pendenciaForm.photo = ''))
                          }, [...(_cache[65] || (_cache[65] = [
                            _createElementVNode("svg", {
                              width: "16",
                              height: "16",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "#fff",
                              "stroke-width": "2.5"
                            }, [
                              _createElementVNode("line", {
                                x1: "18",
                                y1: "6",
                                x2: "6",
                                y2: "18"
                              }),
                              _createElementVNode("line", {
                                x1: "6",
                                y1: "6",
                                x2: "18",
                                y2: "18"
                              })
                            ], -1)
                          ]))])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.pendenciaForm.photo)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "quick-image-add",
                          type: "button",
                          onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.pendenciaPhotoInputRef?.click()))
                        }, [...(_cache[66] || (_cache[66] = [
                          _createElementVNode("svg", {
                            width: "18",
                            height: "18",
                            viewBox: "0 0 18 18",
                            fill: "none"
                          }, [
                            _createElementVNode("path", {
                              d: "M9 4v10M4 9h10",
                              stroke: "currentColor",
                              "stroke-width": "1.6",
                              "stroke-linecap": "round"
                            })
                          ], -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ], 34),
                  _createElementVNode("input", {
                    ref: "pendenciaPhotoInputRef",
                    type: "file",
                    accept: "image/*",
                    style: {"display":"none"},
                    onChange: _cache[40] || (_cache[40] = 
//@ts-ignore
(...args) => (_ctx.onPendenciaPhoto && _ctx.onPendenciaPhoto(...args)))
                  }, null, 544)
                ]),
                (_ctx.pendenciaError)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_44, _toDisplayString(_ctx.pendenciaError), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("button", {
                  class: "btn btn-ghost",
                  type: "button",
                  onClick: _cache[41] || (_cache[41] = 
//@ts-ignore
(...args) => (_ctx.closePendenciaModal && _ctx.closePendenciaModal(...args)))
                }, "Cancelar"),
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  type: "button",
                  disabled: _ctx.pendenciaSaving,
                  onClick: _cache[42] || (_cache[42] = 
//@ts-ignore
(...args) => (_ctx.submitPendencia && _ctx.submitPendencia(...args)))
                }, _toDisplayString(_ctx.pendenciaSaving ? 'Registrando…' : 'Registrar'), 9, _hoisted_46)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]))
  ]))
}